import type { ComponentProps } from 'react';
import Box from '@/components/UI/Box';
import UIButton from '@/components/UI/Button';
import UIText from '@/components/UI/Text';

type NoticeButtonProps = Omit<
  ComponentProps<typeof UIButton>,
  'appearance' | 'variant'
> & {
  action?: ComponentProps<typeof UIButton>['variant'];
};

export function Button({
  action = 'primary',
  maxWidth = 320,
  ...props
}: NoticeButtonProps) {
  return (
    <UIButton
      {...props}
      appearance="outline"
      maxWidth={maxWidth}
      variant={action}
    />
  );
}

export function ButtonText({
  numberOfLines = 1,
  ...props
}: ComponentProps<typeof UIButton.Text>) {
  return <UIButton.Text {...props} numberOfLines={numberOfLines} />;
}

export function Container({
  alignItems = 'center',
  alignSelf = 'center',
  direction = 'vertical',
  flex = true,
  justifyContent = 'center',
  maxWidth = 384,
  p = 'xl',
  space = 'xl',
  ...props
}: ComponentProps<typeof Box>) {
  return (
    <Box
      {...props}
      alignItems={alignItems}
      alignSelf={alignSelf}
      direction={direction}
      flex={flex}
      justifyContent={justifyContent}
      maxWidth={maxWidth}
      p={p}
      space={space}
    />
  );
}

export function Text({
  center = true,
  fontWeight = 'normal',
  size = 'xl',
  ...props
}: ComponentProps<typeof UIText>) {
  return (
    <UIText {...props} center={center} fontWeight={fontWeight} size={size} />
  );
}

export function TextEntity({
  color,
  fontWeight = 'bold',
  size = 'xl',
  variant,
  ...props
}: ComponentProps<typeof UIText>) {
  return (
    <Text
      {...props}
      color={color}
      fontWeight={fontWeight}
      size={size}
      variant={variant ?? (color ? undefined : 'primary')}
    />
  );
}
